import {Component, inject} from 'vue';
import {appsKey} from '@/keys';
import {AppContext, apps, LegacyOrder, LegacyOrderDraftChanges, NavHubSection} from '@hantera/portal-app';

export interface AppComponent {
  key: symbol
  appContext: AppContext
  component: Component
}

// For whatever reason, defining this function as an explicit type seems to help Typescript understand the generic
// relationship between the argument and the return type.
type GetServices = <T>(type: apps.AppService<T>) => T[];

export interface Apps {
  getComponentsFor<T>(area: apps.AppSlot<T>, appId?: string): AppComponent[]
  getServices: GetServices

  getNavHubSections(): NavHubSection[]
  onLegacyOrderSaved(order: LegacyOrder, changes: LegacyOrderDraftChanges[]): Promise<void>
}

export default function useApps() {
  return {
    ...inject<Apps>(appsKey, <any>{}),
    
  };
}